var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.974 3.40783L16.092 5.52483M15.336 1.54283L9.609 7.26983C9.31309 7.56533 9.11128 7.94181 9.029 8.35183L8.5 10.9998L11.148 10.4698C11.558 10.3878 11.934 10.1868 12.23 9.89083L17.957 4.16383C18.1291 3.99173 18.2656 3.78742 18.3588 3.56256C18.4519 3.33771 18.4998 3.09671 18.4998 2.85333C18.4998 2.60994 18.4519 2.36895 18.3588 2.14409C18.2656 1.91923 18.1291 1.71492 17.957 1.54283C17.7849 1.37073 17.5806 1.23421 17.3557 1.14108C17.1309 1.04794 16.8899 1 16.6465 1C16.4031 1 16.1621 1.04794 15.9373 1.14108C15.7124 1.23421 15.5081 1.37073 15.336 1.54283V1.54283Z",
    stroke: "#E66100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12.9999V15.9999C16.5 16.5303 16.2893 17.039 15.9142 17.4141C15.5391 17.7892 15.0304 17.9999 14.5 17.9999H3.5C2.96957 17.9999 2.46086 17.7892 2.08579 17.4141C1.71071 17.039 1.5 16.5303 1.5 15.9999V4.99988C1.5 4.46944 1.71071 3.96074 2.08579 3.58566C2.46086 3.21059 2.96957 2.99988 3.5 2.99988H6.5",
    stroke: "#E66100",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d1ced46a76fc38059689dd8d8019e952.svg";
export { ForwardRef as ReactComponent };